export const map = {
  EXPENSE_RATIO: "04c05009-a8c3-11e9-8b5f-00ff12c3b408",
  CURRENT_BALANCE: "681d83ea-2e11-11e9-ac70-0242ac140002",
  UNFUNDED_COMMITMENT: "681d843a-2e11-11e9-ac70-0242ac140002",
  CURRENT_RATE: "681d8489-2e11-11e9-ac70-0242ac140002",
  PROJECTED_RATE: "681d84db-2e11-11e9-ac70-0242ac140002",
  UPCOMING_PAYMENT: "681d8530-2e11-11e9-ac70-0242ac140002",
  MONTHS_UNTIL_MATURITY: "681d8588-2e11-11e9-ac70-0242ac140002",
  IO_REMAINING: "681d85e0-2e11-11e9-ac70-0242ac140002",
  MAX_RECOURSE: "681d8639-2e11-11e9-ac70-0242ac140002",
  DSCR: "681d8695-2e11-11e9-ac70-0242ac140002",
  DEBT_YIELD: "681d86f1-2e11-11e9-ac70-0242ac140002",
  LTV: "681d874f-2e11-11e9-ac70-0242ac140002",
  PREPAYMENT: "681d87af-2e11-11e9-ac70-0242ac140002",
  COVENANT_TEST_FREQUENCY: "681d8811-2e11-11e9-ac70-0242ac140002",
  DEBT_RSF: "681d8875-2e11-11e9-ac70-0242ac140002",
  DEBT_MF_UNIT: "681d88da-2e11-11e9-ac70-0242ac140002",
  PROJECTED_EXIT_DATE: "681d8941-2e11-11e9-ac70-0242ac140002",
  CAP_RATE: "681d89aa-2e11-11e9-ac70-0242ac140002",
  PROJECT_TYPE: "681d8a14-2e11-11e9-ac70-0242ac140002",
  PURCHASE_DATE: "681d8a80-2e11-11e9-ac70-0242ac140002",
  PURCHASE_PRICE: "681d8aee-2e11-11e9-ac70-0242ac140002",
  MATURITY_DATE: "681d8b5e-2e11-11e9-ac70-0242ac140002",
  EXTENDED_MATURITY_DATE: "681d8bd0-2e11-11e9-ac70-0242ac140002",
  LENDER: "681d8c43-2e11-11e9-ac70-0242ac140002",
  BORROWING_ENTITY: "681d8cb8-2e11-11e9-ac70-0242ac140002",
  HEDGE_TYPE: "681d8d2e-2e11-11e9-ac70-0242ac140002",
  HEDGE_MATURITY: "681d8da7-2e11-11e9-ac70-0242ac140002",
  HEDGE_MTM: "681d8e24-2e11-11e9-ac70-0242ac140002",
  NOI: "65ab82e1-baaf-11e9-9019-0242ac120002",
  OCCUPANCY: "74045550-baaf-11e9-9019-0242ac120002",
  APPRAISED_VALUE: "681d8ea1-2e11-11e9-ac70-0242ac140002",
  EQUITY: "c69ee423-aa37-11e9-8b5f-00ff12c3b408",
  CURRENT_BALANCE_SENIOR_SUPP: "c69ee880-aa37-11e9-8b5f-00ff12c3b408",
  ALL_IN_RATE: "f98d5a99-c2be-11e9-a4f9-00ff12c3b408",
  LTV_SUBORDINATE: "9289e6e4-c825-11e9-a4f9-00ff12c3b408",
  DEBT_YIELD_SUBORDINATE: "9289e729-c825-11e9-a4f9-00ff12c3b408",
  DSCR_LENDER_SUBORDINATE: "9289e730-c825-11e9-a4f9-00ff12c3b408",
  DSCR_ACTUAL_SUBORDINATE: "9289e735-c825-11e9-a4f9-00ff12c3b408",
  NOI_ACTUAL: "fe2a5a3e-c825-11e9-a4f9-00ff12c3b408",
  DSCR_ACTUAL: "f4db2745-c826-11e9-a4f9-00ff12c3b408",
  TOTAL_OCCUPIED_SQUARE_FEET: "a234acef-b9ff-11e9-9b20-00ff12c3b408",
  TOTAL_OCCUPIED_WEIGHTED_SQUARE_FEET: "a8d7ae99-b9ee-11e9-9b20-00ff12c3b408",
  REFI_PROCEEDS: "8d06bbf3-8ec8-11ea-9df5-2c4d543da462",
  INTERNAL_EQUITY_OWNERSHIP: "89fbc447-d5c3-4453-8a24-30ec2e51f38e",
  EXTERNAL_EQUITY_OWNERSHIP: "8e7832c9-6bc2-4fc4-b938-f478c0f7354a",
  GOOD_NEWS_MONEY_REMAINING_DOLLAR_AMOUNT: "593a308c-e248-11ea-845c-802bf905d5f8",
  GOOD_NEWS_MONEY_REMAINING_PERCENT: "4db220b3-e2f1-11ea-845c-802bf905d5f8",
  AGGREGATE_RECOURSE: "c5ca6d14-9eab-11eb-b02e-98fa9bde2f84",
  EXTENSION_QUALIFICATION: "ee41cce2-e2f4-11ea-845c-802bf905d5f8",
  DEVELOPMENT_COST: "75111970-0fa4-11eb-9711-98fa9bde2f84",
  SQUARE_FEET: "9c6969cc-1855-11eb-b24c-98fa9bde2f84",
  MF_UNITS: "9c6969c5-1855-11eb-b24c-98fa9bde2f84",
  SALES_PRICE: "9c6969bd-1855-11eb-b24c-98fa9bde2f84",
  EXIT_CAP: "9c696954-1855-11eb-b24c-98fa9bde2f84",
  CLOSING_DATE: "12042c12-186d-11eb-b24c-98fa9bde2f84",
  EXIT_DATE: "8002557f-1873-11eb-b24c-98fa9bde2f84",
  NOI_LENDER_PLUSFIFTEEN: "315d1fc3-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_LENDER_PLUSTEN: "315d1fcc-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_LENDER_PLUSFIVE: "315d1fd3-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_LENDER_MINUSFIVE: "315d1fdb-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_LENDER_MINUSTEN: "315d1fe2-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_LENDER_MINUSFIFTEEN: "315d1fe8-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_ACTUAL_PLUSFIFTEEN: "315d1ff0-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_ACTUAL_PLUSTEN: "315d1ff6-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_ACTUAL_PLUSFIVE: "315d1ffc-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_ACTUAL_MINUSFIVE: "315d2002-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_ACTUAL_MINUSTEN: "315d200a-a69f-11eb-b795-0a0ed7ec18e7",
  NOI_ACTUAL_MINUSFIFTEEN: "315d2010-a69f-11eb-b795-0a0ed7ec18e7",
  DEBT_YIELD_PLUSFIFTEEN: "50040a06-a6aa-11eb-b795-0a0ed7ec18e7",
  DEBT_YIELD_PLUSTEN: "50040a5b-a6aa-11eb-b795-0a0ed7ec18e7",
  DEBT_YIELD_PLUSFIVE: "50040a64-a6aa-11eb-b795-0a0ed7ec18e7",
  DEBT_YIELD_MINUSFIVE: "50040a6c-a6aa-11eb-b795-0a0ed7ec18e7",
  DEBT_YIELD_MINUSTEN: "50040a73-a6aa-11eb-b795-0a0ed7ec18e7",
  DEBT_YIELD_MINUSFIFTEEN: "50040a7b-a6aa-11eb-b795-0a0ed7ec18e7"

};
export const list = Object.values(map);

export default {
  map,
  list
};
